<template>
  <!-- index.html   13:53:02 GMT -->
  <head>
    <meta charset="utf-8" />
    <title>Desk Birdy | Parking Quick Stats</title>
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta content="Rental management system by Nouveta LTD" name="description" />
    <meta content="Kelvin Njuguna" name="author" />
    <!-- App favicon -->
    <link rel="shortcut icon" href="assets/images/favicon.svg">
    <!-- droping file -->
    <link href="assets/libs/dropzone/min/dropzone.min.css" rel="stylesheet" type="text/css" />

    <!-- DataTables -->
    <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet" type="text/css" />
    <link href="assets/libs/datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css" rel="stylesheet" type="text/css" />

    <!-- Slick carousel -->
    <link rel="stylesheet" href="assets/libs/slick/slick.css"/>
    <link rel="stylesheet" href="assets/libs/slick/slick-theme.css"/>

    <!-- Bootstrap Css -->
    <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
    <!-- Bootstrap select styling -->
    <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css">
    <!-- Icons Css -->
    <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />
    <!-- App Css-->
    <!-- owl.carousel css -->
    <link rel="stylesheet" href="assets/libs/owl.carousel/assets/owl.carousel.min.css">
    <link rel="stylesheet" href="assets/libs/owl.carousel/assets/owl.theme.default.min.css">
    <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
    <!-- custom Css-->
    <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css" />
  </head>

  <body @contextmenu.prevent data-sidebar="dark">
  <!-- Begin page -->
  <div id="layout-wrapper">
    <NavigationBar/>

    <!-- Start right Content here -->
    <div id="content" class="content-minimize">
      <div class="page-content">
        <div class="container-fluid">

          <!-- start page title -->
          <div class="row">
            <div class="col-12">
              <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 class="mb-sm-0 font-size-18">
                  {{ countyData ? `${countyData.countyName} ` : '' }}Plot Rent Register - Cadastral Map View
                </h4>
                <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><a href="javascript: void(0);">Dashboards</a></li>
                    <li class="breadcrumb-item"><a href="javascript: void(0);">Land & Plots</a></li>
                    <li class="breadcrumb-item active">Cadastral Map</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
          <!-- end page title -->

          <ToolBarPlot/>

          <!-- Map Controls -->
          <div class="row mb-3">
            <div class="col-12">
              <div class="card">
                <div class="card-body">
                  <div class="row align-items-center">
                    <div class="col-md-8">
                      <div class="d-flex align-items-center">
                        <div class="me-3">
                              <span class="badge badge-soft-success me-2 animate__animated animate__fadeInUp" style="animation-delay: 0.1s">
                                <i class="mdi mdi-square me-1" style="color: green;"></i>
                                Compliant ({{ compliantCount }})
                              </span>
                          <span class="badge badge-soft-danger me-2 animate__animated animate__fadeInUp" style="animation-delay: 0.2s">
                                <i class="mdi mdi-square me-1" style="color: red;"></i>
                                Outstanding Arrears ({{ arrearsCount }})
                              </span>
                          <span class="badge badge-soft-warning me-2 animate__animated animate__fadeInUp" style="animation-delay: 0.3s">
                                <i class="mdi mdi-square me-1" style="color: yellow;"></i>
                                Under Review ({{ reviewCount }})
                              </span>
                          <span class="badge badge-soft-info animate__animated animate__fadeInUp" v-if="dataSource" style="animation-delay: 0.4s">
                                <i class="mdi mdi-database me-1"></i>
                                {{ dataSource === 'cache' ? 'Cached Data' : dataSource === 'download' ? 'Fresh Download' : 'Offline' }}
                              </span>
                        </div>
                      </div>
                      <div v-if="isLoading" class="mt-2">
                        <div class="progress cinematic-progress" style="height: 8px;">
                          <div class="progress-bar progress-bar-striped progress-bar-animated cinematic-bar"
                               :style="{width: downloadProgress + '%'}"
                               :class="{'bg-success': downloadProgress === 100}">
                          </div>
                        </div>
                        <small class="text-muted animate__animated animate__pulse animate__infinite">
                          <i class="mdi mdi-satellite-variant me-1"></i>{{ loadingStatus }}
                        </small>
                      </div>
                    </div>
                    <div class="col-md-4 text-end">
                      <button class="btn btn-primary btn-sm me-2 animate__animated animate__fadeInRight" @click="toggleMapType" style="animation-delay: 0.5s">
                        <i class="mdi mdi-map"></i> {{ mapType === 'satellite' ? 'Map' : 'Satellite' }}
                      </button>
                      <button class="btn btn-success btn-sm animate__animated animate__fadeInRight" @click="exportData" style="animation-delay: 0.6s">
                        <i class="mdi mdi-download"></i> Export
                      </button>
                      <button class="btn btn-info btn-sm ms-2 animate__animated animate__fadeInRight" @click="reloadData" v-if="!isLoading" style="animation-delay: 0.7s">
                        <i class="mdi mdi-refresh"></i> Reload
                      </button>
                      <button class="btn btn-warning btn-sm ms-2 animate__animated animate__fadeInRight" @click="clearCache" v-if="!isLoading && dataSource === 'cache'" style="animation-delay: 0.8s">
                        <i class="mdi mdi-trash"></i> Clear Cache
                      </button>
                      <button class="btn btn-secondary btn-sm ms-2 animate__animated animate__fadeInRight" @click="toggleMeasurementTool" v-if="!isLoading" style="animation-delay: 0.9s">
                        <i class="mdi mdi-ruler"></i> {{ measurementMode ? 'Stop Measuring' : 'Measure' }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- County Info Banner -->
          <div class="row mb-3" v-if="countyData">
            <div class="col-12">
              <div class="card border-primary">
                <div class="card-body py-2">
                  <div class="d-flex align-items-center">
                    <img v-if="countyData.logo" :src="countyData.logo" alt="County Logo" class="me-3" style="height: 40px; width: auto;">
                    <div class="flex-grow-1">
                      <h6 class="mb-0 text-primary">{{ countyData.countyNameFull || countyData.countyName }}</h6>
                      <small class="text-muted">{{ countyData.tagline }}</small>
                    </div>
                    <div class="text-end">
                      <small class="text-muted">
                        <i class="mdi mdi-phone me-1"></i>{{ countyData.contact }}
                        <br>
                        <i class="mdi mdi-email me-1"></i>{{ countyData.email }}
                      </small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Main Map Container -->
          <div class="row">
            <div class="col-12">
              <div class="card">
                <div class="card-body p-0">
                  <div class="main-map-container position-relative">

                    <!-- Cinematic Loading Overlay -->
                    <div v-if="isLoading && cinematicMode" class="cinematic-overlay position-absolute w-100 h-100" style="z-index: 2000;">
                      <div class="cinematic-content">
                        <div class="earth-animation">
                          <div class="rotating-earth">
                            <i class="mdi mdi-earth" style="font-size: 80px; color: #4285f4;"></i>
                          </div>
                        </div>
                        <div class="loading-text mt-4">
                          <h4 class="text-white mb-3 animate__animated animate__fadeInUp">
                            <i class="mdi mdi-satellite-variant me-2"></i>Initializing {{ countyData ? countyData.countyName : 'County' }} Satellite View
                          </h4>
                          <div class="scanning-line"></div>
                          <p class="text-light animate__animated animate__fadeInUp animate__delay-1s">
                            {{ loadingStatus || 'Connecting to orbital systems...' }}
                          </p>
                          <div class="progress cinematic-main-progress mt-3" style="height: 4px;">
                            <div class="progress-bar bg-gradient-primary"
                                 :style="{width: downloadProgress + '%'}"
                                 style="box-shadow: 0 0 20px rgba(66, 133, 244, 0.5);">
                            </div>
                          </div>
                          <small class="text-muted mt-2 d-block">{{ downloadProgress }}% Complete</small>
                        </div>
                      </div>
                    </div>

                    <!-- Google Map -->
                    <div id="map" style="height: 600px; width: 100%;" :class="{'map-loading': isLoading}"></div>

                    <!-- Floating Info Panel -->
                    <div id="follow-text" class="d-none position-absolute bg-dark text-white p-2 rounded shadow-sm"
                         style="z-index: 1000; pointer-events: none; font-size: 12px; max-width: 200px;">
                    </div>

                    <!-- Side Panel for Plot Details -->
                    <aside id="mapCanvas" class="map-details-panel left-100 position-absolute bg-white shadow-lg"
                           style="top: 0; right: 0; width: 400px; height: 100%; z-index: 999; transition: all 0.3s;">
                      <div class="p-3 border-bottom bg-primary text-white">
                        <div class="d-flex justify-content-between align-items-center">
                          <h5 class="mb-0 text-white">Plot Details</h5>
                          <button class="btn btn-sm btn-outline-light close-aside">
                            <i class="mdi mdi-close"></i>
                          </button>
                        </div>
                      </div>

                      <div class="p-3">
                        <!-- Plot Status Alert -->
                        <div class="alert plot-status border-2 mb-3">
                          <div class="d-flex justify-content-between align-items-center">
                            <span class="fw-bold">Current Balance</span>
                            <span class="balance-txt fw-bold balances">KES 0.00</span>
                          </div>
                        </div>

                        <!-- Basic Information -->
                        <div class="mb-4">
                          <h6 class="text-muted mb-2">Basic Information</h6>
                          <div class="row g-2">
                            <div class="col-6">
                              <small class="text-muted d-block">Owner Name</small>
                              <span class="owner-name fw-bold">-</span>
                            </div>
                            <div class="col-6">
                              <small class="text-muted d-block">LR Number</small>
                              <span class="lr-no fw-bold">-</span>
                            </div>
                            <div class="col-6">
                              <small class="text-muted d-block">Block Name</small>
                              <span class="block-name">-</span>
                            </div>
                            <div class="col-6">
                              <small class="text-muted d-block">Plot Number</small>
                              <span class="plot-number">-</span>
                            </div>
                            <div class="col-6">
                              <small class="text-muted d-block">UPN</small>
                              <span class="upn">-</span>
                            </div>
                            <div class="col-6">
                              <small class="text-muted d-block">Size</small>
                              <span class="size">-</span>
                            </div>
                          </div>
                        </div>

                        <!-- Financial Information -->
                        <div class="mb-4">
                          <h6 class="text-muted mb-2">Financial Details</h6>
                          <div class="row g-2">
                            <div class="col-12">
                              <div class="d-flex justify-content-between">
                                <small class="text-muted">Site Value:</small>
                                <span class="site-value">KES 0.00</span>
                              </div>
                            </div>
                            <div class="col-12">
                              <div class="d-flex justify-content-between">
                                <small class="text-muted">Annual Charges:</small>
                                <span class="annual-charges">KES 0.00</span>
                              </div>
                            </div>
                            <div class="col-12">
                              <div class="d-flex justify-content-between">
                                <small class="text-muted">Land Rate:</small>
                                <span class="land-rate">KES 0.00</span>
                              </div>
                            </div>
                            <div class="col-12">
                              <div class="d-flex justify-content-between">
                                <small class="text-muted">Ground Rent:</small>
                                <span class="ground-rate">KES 0.00</span>
                              </div>
                            </div>
                            <div class="col-12">
                              <div class="d-flex justify-content-between">
                                <small class="text-muted">Other Charges:</small>
                                <span class="other-charges">KES 0.00</span>
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- Location Information -->
                        <div class="mb-4">
                          <h6 class="text-muted mb-2">Location</h6>
                          <div class="row g-2">
                            <div class="col-12">
                              <small class="text-muted d-block">Market Center</small>
                              <span class="market">-</span>
                            </div>
                            <div class="col-12">
                              <small class="text-muted d-block">Address</small>
                              <span class="the-clicked-address">-</span>
                            </div>
                          </div>
                        </div>

                        <!-- Actions -->
                        <div class="d-grid gap-2 d-none">
                          <button class="btn btn-primary" @click="viewFullDetails">
                            <i class="mdi mdi-eye"></i> View Full Details
                          </button>
                          <button class="btn btn-outline-secondary" @click="generateStatement">
                            <i class="mdi mdi-file-document"></i> Generate Statement
                          </button>
                        </div>
                      </div>
                    </aside>

                    <!-- Backdrop overlay -->
                    <div class="ma-backdrop d-none position-absolute w-100 h-100"
                         style="top: 0; left: 0; background: rgba(0,0,0,0.3); z-index: 998;">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- end row -->
        </div>
        <!-- container-fluid -->
      </div>
      <!-- End Page-content -->
    </div>
    <!-- end content -->
  </div>
  <!-- END layout-wrapper -->

  <!-- Right bar overlay-->
  <div class="rightbar-overlay"></div>
  </body>
</template>

<script>
/* eslint-disable */
import NavigationBar from "@/components/Navigation.vue";
import { base, authUrl, biller, execute, execute2, executeDownload, executeJson, getRight, landRate, plotRentUploads } from "@/api";
import ToolBarPlot from "@/components/landrate/ToolBar.vue";

export default {
  name: "LandGIS",
  components: {
    ToolBarPlot,
    NavigationBar
  },
  data() {
    return {
      map: null,
      cadastralLayer: null,
      mapType: 'satellite', // Default to satellite
      compliantCount: 0,
      arrearsCount: 0,
      reviewCount: 0,
      currentFeature: null,
      cadastralData: null,
      loadingStatus: '',
      isLoading: false,
      cinematicMode: true,
      downloadProgress: 0,
      dataSource: 'cache',
      cacheVersion: '1.0',
      cacheExpiryDays: 30,
      dbName: 'CadastralDB',
      dbVersion: 1,
      cadastralDB: null,
      // County data
      countyData: null,
      defaultCenter: { lat: 0.04986230310348805, lng: 37.64667110366901 }, // Default to Meru coordinates
      // Map control properties
      currentLocationMarker: null,
      measurementMode: false,
      measurementOverlays: [],
      measurementPath: [],
      measurementListener: null
    }
  },
  watch: {
    // Add watchers if needed
  },
  mounted() {
    // Initialize county data first, then cadastral data and map
    this.$nextTick(async () => {
      await this.fetchCountyData();
      await this.initializeCadastralData();
    });
  },
  computed: {
    mapCenter() {
      if (this.countyData && this.countyData.lat && this.countyData.lng) {
        const center = {
          lat: parseFloat(this.countyData.lat),
          lng: parseFloat(this.countyData.lng)
        };
        console.log('Using county center:', center);
        return center;
      }
      console.log('Using default center:', this.defaultCenter);
      return this.defaultCenter;
    }
  },
  methods: {
    // Fetch county data
    async fetchCountyData() {
      try {
        this.loadingStatus = 'Loading county information...';

        // Create FormData for the API call
        const formData = new FormData();
        formData.append('function', 'getCounty');

        const response = await execute(formData, landRate);

        if (response.data && response.data.success && response.data.data.county) {
          this.countyData = response.data.data.county;
          console.log('County data loaded:', this.countyData);

          // Update the page title with county name if available
          if (this.countyData && this.countyData.countyName) {
            document.title = `${this.countyData.countyName} | Cadastral Map View`;
          }
        } else {
          console.warn('County data not available, using defaults');
        }
      } catch (error) {
        console.error('Error fetching county data:', error);
        this.loadingStatus = 'County data unavailable, using defaults';
      }
    },

    // Initialize cadastral data management with cinematic effect
    async initializeCadastralData() {
      this.isLoading = true;
      this.cinematicMode = true;
      this.loadingStatus = 'Initializing orbital connection...';

      try {
        // Simulate cinematic startup delay
        await new Promise(resolve => setTimeout(resolve, 1000));

        this.loadingStatus = 'Accessing satellite network...';
        await new Promise(resolve => setTimeout(resolve, 800));

        // Initialize IndexedDB
        await this.initIndexedDB();

        // Check if we have valid cached data
        if (await this.hasValidCache()) {
          this.loadingStatus = 'Loading cached satellite imagery...';
          this.dataSource = 'cache';
          await this.loadFromCache();
        } else {
          this.loadingStatus = 'Downloading high-resolution cadastral data...';
          this.dataSource = 'download';

          // Try your API pattern first (exactly like getLandRates)
          try {
            const apiData = await this.fetchCadastralDataViaAPI();
            if (apiData && apiData.features) {
              await this.storeInCache(apiData);
              this.cadastralData = apiData;
              this.loadingStatus = `Loaded ${apiData.features.length} plots via satellite`;

              // Also fetch stats via API
              await this.fetchCadastralStats();

              // Initialize Google Maps after data is ready
              await this.initializeGoogleMaps();
              return;
            }
          } catch (apiError) {
            console.warn('Satellite feed failed, trying terrestrial backup:', apiError.message);
            this.loadingStatus = 'Switching to terrestrial backup systems...';
          }

          // Fallback to direct file access
          try {
            await this.downloadAndCache();
          } catch (error) {
            console.error('All cadastral data sources offline:', error);
            this.loadingStatus = 'No cadastral data available - Map ready for manual upload';
            this.dataSource = 'offline';
            // Don't load sample data, just show empty map
          }
        }

        // Initialize Google Maps after data is ready
        await this.initializeGoogleMaps();

      } catch (error) {
        console.error('Critical system failure:', error);
        this.loadingStatus = 'No cadastral data available - Map initialized';
        this.dataSource = 'offline';
        // Try to initialize map anyway without sample data
        await this.initializeGoogleMaps();
      } finally {
        // Cinematic shutdown sequence
        this.loadingStatus = 'Finalizing satellite lock...';
        await new Promise(resolve => setTimeout(resolve, 1000));

        this.loadingStatus = `System ready - ${this.countyData?.countyName || 'County'} map initialized`;
        await new Promise(resolve => setTimeout(resolve, 1500));

        this.isLoading = false;
        this.cinematicMode = false;
      }
    },

    // Initialize IndexedDB
    async initIndexedDB() {
      return new Promise((resolve, reject) => {
        const request = indexedDB.open(this.dbName, this.dbVersion);

        request.onerror = () => reject(request.error);
        request.onsuccess = () => {
          this.cadastralDB = request.result;
          resolve();
        };

        request.onupgradeneeded = (event) => {
          const db = event.target.result;

          // Create object store for cadastral data
          if (!db.objectStoreNames.contains('cadastralData')) {
            const store = db.createObjectStore('cadastralData', { keyPath: 'id' });
            store.createIndex('timestamp', 'timestamp', { unique: false });
            store.createIndex('version', 'version', { unique: false });
          }
        };
      });
    },

    // Check if we have valid cached data
    async hasValidCache() {
      try {
        const cached = await this.getCachedData();
        if (!cached) return false;

        // Check version
        if (cached.version !== this.cacheVersion) return false;

        // Check expiry
        const daysSinceCache = (Date.now() - cached.timestamp) / (1000 * 60 * 60 * 24);
        if (daysSinceCache > this.cacheExpiryDays) return false;

        return true;
      } catch (error) {
        console.error('Error checking satellite cache:', error);
        return false;
      }
    },

    // Get cached data from IndexedDB
    async getCachedData() {
      return new Promise((resolve, reject) => {
        const transaction = this.cadastralDB.transaction(['cadastralData'], 'readonly');
        const store = transaction.objectStore('cadastralData');
        const request = store.get('main');

        request.onsuccess = () => resolve(request.result);
        request.onerror = () => reject(request.error);
      });
    },

    // Load data from cache
    async loadFromCache() {
      try {
        const cached = await this.getCachedData();
        if (cached && cached.data) {
          this.cadastralData = cached.data;
          this.loadingStatus = `Loaded ${cached.data.features?.length || 0} plots from orbital cache`;
          console.log('Data loaded from satellite cache successfully');

          // Simulate progressive loading for cinematic effect
          for (let i = 0; i <= 100; i += 10) {
            this.downloadProgress = i;
            await new Promise(resolve => setTimeout(resolve, 50));
          }

          // Clear loading status after 2 seconds
          setTimeout(() => {
            this.loadingStatus = '';
          }, 2000);
        }
      } catch (error) {
        console.error('Error loading from satellite cache:', error);
        this.loadingStatus = 'Cache corrupted, downloading fresh satellite data...';
        await this.downloadAndCache();
      }
    },

    // Alternative method using your existing API pattern
    async fetchCadastralDataViaAPI() {
      try {
        this.loadingStatus = 'Fetching data via secure satellite uplink...';

        // Create FormData for your API
        const formData = new FormData();
        formData.append('function', 'getCadastralData');

        // Use your existing execute function
        const response = await execute(formData, landRate);

        if (response.data && response.data.success) {
          return response.data.cadastralData;
        } else {
          throw new Error('Satellite uplink returned no data');
        }
      } catch (error) {
        console.error('Satellite uplink failed:', error);
        throw error;
      }
    },

    // Fetch cadastral stats via API
    async fetchCadastralStats() {
      try {
        const formData = new FormData();
        formData.append('function', 'getCadastralStats');

        const response = await execute(formData, landRate);

        if (response.data && response.data.success) {
          const stats = response.data.stats;
          this.compliantCount = stats.compliant || 0;
          this.arrearsCount = stats.arrears || 0;
          this.reviewCount = stats.review || 0;
        }
      } catch (error) {
        console.warn('Failed to fetch stats via satellite:', error);
        // Calculate stats locally as fallback
        this.calculateStats();
      }
    },

    // Download and cache cadastral data with cinematic progress
    async downloadAndCache() {
      try {
        this.downloadProgress = 0;
        this.loadingStatus = 'Establishing secure satellite connection...';

        // Try multiple data sources (prioritize local file for reliability)
        const dataSources = [
          'assets/js/KisumuCadastralSample2.json',
          '/api/landrate/uploads/cadastral.json',
          `${process.env.VUE_APP_API_BASE_URL || ''}/api/landrate/uploads/cadastral.json`,
          'https://kerichopay.co.ke/api/landrate/uploads/cadastral.json'
        ];

        let response = null;
        let lastError = null;

        for (const url of dataSources) {
          try {
            this.loadingStatus = `Connecting to ${url.includes('assets') ? 'local satellite array' : 'orbital data center'}...`;
            response = await fetch(url);

            if (response.ok) {
              break; // Success, exit the loop
            } else {
              throw new Error(`Satellite feed error! status: ${response.status}`);
            }
          } catch (error) {
            console.warn(`Failed to connect to ${url}:`, error.message);
            lastError = error;
            response = null;
          }
        }

        if (!response || !response.ok) {
          throw lastError || new Error('All satellite feeds offline');
        }

        const contentLength = response.headers.get('content-length');
        const total = parseInt(contentLength, 10);
        let loaded = 0;

        const reader = response.body.getReader();
        const chunks = [];

        while (true) {
          const { done, value } = await reader.read();
          if (done) break;

          chunks.push(value);
          loaded += value.length;

          if (total) {
            this.downloadProgress = Math.round((loaded / total) * 100);
            this.loadingStatus = `Downloading satellite imagery... ${this.downloadProgress}% (${this.formatBytes(loaded)}/${this.formatBytes(total)})`;
          } else {
            // Simulate progress for unknown total
            this.downloadProgress = Math.min(this.downloadProgress + Math.random() * 5, 95);
            this.loadingStatus = `Receiving orbital data stream... ${Math.round(this.downloadProgress)}%`;
          }

          // Add cinematic delay
          await new Promise(resolve => setTimeout(resolve, 30));
        }

        // Convert chunks to JSON
        this.loadingStatus = 'Processing satellite imagery...';
        this.downloadProgress = 98;

        const uint8Array = new Uint8Array(loaded);
        let offset = 0;
        for (const chunk of chunks) {
          uint8Array.set(chunk, offset);
          offset += chunk.length;
        }

        const text = new TextDecoder().decode(uint8Array);
        const data = JSON.parse(text);

        // Store in cache
        this.loadingStatus = 'Caching satellite data...';
        this.downloadProgress = 100;
        await this.storeInCache(data);

        this.cadastralData = data;
        this.loadingStatus = `Downloaded and cached ${data.features?.length || 0} plots from satellite`;

        console.log('Satellite data downloaded and cached successfully');

        // Clear loading status after 3 seconds
        setTimeout(() => {
          this.loadingStatus = '';
        }, 3000);

      } catch (error) {
        console.error('Error downloading satellite data:', error);
        this.loadingStatus = 'No cadastral data sources available';
        this.dataSource = 'offline';
        // Don't fallback to sample data
      }
    },

    // Store data in IndexedDB cache
    async storeInCache(data) {
      return new Promise((resolve, reject) => {
        const transaction = this.cadastralDB.transaction(['cadastralData'], 'readwrite');
        const store = transaction.objectStore('cadastralData');

        const cacheEntry = {
          id: 'main',
          data: data,
          timestamp: Date.now(),
          version: this.cacheVersion,
          size: JSON.stringify(data).length
        };

        const request = store.put(cacheEntry);
        request.onsuccess = () => {
          console.log('Satellite data stored in orbital cache successfully');
          resolve();
        };
        request.onerror = () => reject(request.error);
      });
    },

    // Initialize Google Maps with satellite view and cinematic intro
    async initializeGoogleMaps() {
      if (typeof google !== 'undefined') {
        await this.initializeMap();
      } else {
        this.loadingStatus = 'Loading Google Earth engine...';
        this.loadGoogleMaps();
      }
    },

    loadGoogleMaps() {
      // Check if Google Maps is available every 500ms
      const checkGoogleMaps = setInterval(() => {
        if (typeof google !== 'undefined') {
          clearInterval(checkGoogleMaps);
          this.loadingStatus = 'Google Earth engine loaded, initializing orbital view...';
          this.initializeMap();
        }
      }, 500);

      // Fallback timeout after 10 seconds
      setTimeout(() => {
        clearInterval(checkGoogleMaps);
        if (typeof google === 'undefined') {
          console.error('Google Earth engine failed to load');
          this.loadingStatus = 'Failed to load Google Earth engine';
          alert('Google Earth engine failed to load. Please check your internet connection and API key.');
        }
      }, 10000);
    },

    async initializeMap() {
      try {
        console.log('Initializing orbital view interface...');
        console.log('Map center coordinates:', this.mapCenter);
        console.log('County data available:', !!this.countyData);

        // Ensure we have the correct center coordinates
        const mapCenter = this.mapCenter;

        // Initialize Google Maps with satellite view and enhanced controls
        this.map = new google.maps.Map(document.getElementById("map"), {
          center: mapCenter, // Use county-specific center
          zoom: 6, // Start very zoomed out for dramatic cinematic effect
          mapTypeId: this.mapType, // Now defaults to 'satellite'
          // Enhanced map controls
          zoomControl: true,
          zoomControlOptions: {
            position: google.maps.ControlPosition.RIGHT_BOTTOM,
            style: google.maps.ZoomControlStyle.LARGE
          },
          panControl: true,
          panControlOptions: {
            position: google.maps.ControlPosition.TOP_LEFT
          },
          mapTypeControl: true,
          mapTypeControlOptions: {
            style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
            position: google.maps.ControlPosition.TOP_RIGHT,
            mapTypeIds: [
              google.maps.MapTypeId.SATELLITE,
              google.maps.MapTypeId.HYBRID,
              google.maps.MapTypeId.ROADMAP,
              google.maps.MapTypeId.TERRAIN
            ]
          },
          scaleControl: true,
          scaleControlOptions: {
            position: google.maps.ControlPosition.BOTTOM_LEFT
          },
          streetViewControl: true,
          streetViewControlOptions: {
            position: google.maps.ControlPosition.RIGHT_BOTTOM
          },
          fullscreenControl: true,
          fullscreenControlOptions: {
            position: google.maps.ControlPosition.TOP_RIGHT
          },
          rotateControl: true,
          rotateControlOptions: {
            position: google.maps.ControlPosition.LEFT_CENTER
          },
          // Additional map options for cinematic effect
          gestureHandling: 'cooperative',
          clickableIcons: false,
          disableDoubleClickZoom: false,
          draggable: true,
          keyboardShortcuts: true,
          scrollwheel: true,
          tilt: 0, // Start with no tilt
          styles: [
            {
              featureType: "poi",
              elementType: "labels",
              stylers: [{ visibility: "off" }]
            }
          ]
        });

        console.log('Orbital view interface initialized successfully');

        // Cinematic zoom-in effect
        await this.cinematicZoomIn();

        // Add custom controls
        this.addCustomControls();

        // Create cadastral layer
        this.cadastralLayer = new google.maps.Data({
          map: this.map,
          clickable: true
        });

        console.log('Satellite data layer created');

        // Process cadastral data if available
        if (this.cadastralData) {
          await this.processCadastralData(this.cadastralData);
        } else {
          // No cadastral data available - show empty map with message
          this.loadingStatus = 'Map ready - No cadastral data loaded. Upload data to view plots.';
          setTimeout(() => {
            this.loadingStatus = '';
          }, 5000);
        }

      } catch (error) {
        console.error('Error initializing orbital view:', error);
        this.loadingStatus = 'Error initializing orbital interface';
      }
    },

    // Enhanced cinematic zoom-in effect
    async cinematicZoomIn() {
      return new Promise((resolve) => {
        this.loadingStatus = 'Descending from orbital altitude...';

        // Multi-stage zoom animation for dramatic effect
        let currentZoom = 6;
        const targetZoom = 15; // Zoom in much closer
        let stage = 1;

        const zoomInterval = setInterval(() => {
          if (currentZoom < targetZoom) {
            // Variable zoom speed for cinematic effect
            let zoomIncrement = 0.3;

            if (stage === 1 && currentZoom < 10) {
              // Stage 1: Slow descent from space
              zoomIncrement = 0.4;
              this.loadingStatus = 'Descending through atmosphere...';
            } else if (stage === 2 && currentZoom < 13) {
              // Stage 2: Medium speed approach
              zoomIncrement = 0.5;
              this.loadingStatus = 'Approaching target region...';
              stage = 2;
            } else if (currentZoom >= 10 && stage === 1) {
              // Stage 3: Final approach
              stage = 3;
              zoomIncrement = 0.3;
              this.loadingStatus = `Final approach - locking onto ${this.countyData?.countyName || 'cadastral'} area...`;
            }

            currentZoom += zoomIncrement;
            this.map.setZoom(currentZoom);

            // Add slight random center adjustments for realism
            const currentCenter = this.map.getCenter();
            const jitter = 0.0001; // Very small movement
            const newLat = currentCenter.lat() + (Math.random() - 0.5) * jitter;
            const newLng = currentCenter.lng() + (Math.random() - 0.5) * jitter;
            this.map.setCenter({ lat: newLat, lng: newLng });

          } else {
            clearInterval(zoomInterval);
            this.loadingStatus = `Satellite lock achieved - ${this.countyData?.countyName || 'cadastral'} view active`;

            // Final centering - ensure we center on the correct coordinates
            setTimeout(() => {
              const finalCenter = this.mapCenter;
              console.log('Final centering on:', finalCenter);
              this.map.setCenter(finalCenter);
              resolve();
            }, 500);
          }
        }, 150); // Faster intervals for smoother animation
      });
    },

    // Add custom map controls
    addCustomControls() {
      // Custom Home Button Control with satellite icon
      const homeControlDiv = document.createElement('div');
      homeControlDiv.style.margin = '10px';
      homeControlDiv.style.cursor = 'pointer';
      homeControlDiv.style.backgroundColor = 'rgba(0,0,0,0.8)';
      homeControlDiv.style.border = '2px solid #4285f4';
      homeControlDiv.style.borderRadius = '5px';
      homeControlDiv.style.boxShadow = '0 4px 15px rgba(66, 133, 244, 0.3)';
      homeControlDiv.style.textAlign = 'center';
      homeControlDiv.style.width = '45px';
      homeControlDiv.style.height = '45px';
      homeControlDiv.style.lineHeight = '45px';
      homeControlDiv.style.transition = 'all 0.3s ease';
      homeControlDiv.innerHTML = '<i class="mdi mdi-satellite-variant" style="font-size: 20px; color: #4285f4;"></i>';
      homeControlDiv.title = `Return to ${this.countyData?.countyName || 'County'} Overview`;

      homeControlDiv.addEventListener('mouseenter', () => {
        homeControlDiv.style.backgroundColor = 'rgba(66, 133, 244, 0.9)';
        homeControlDiv.querySelector('i').style.color = 'white';
      });

      homeControlDiv.addEventListener('mouseleave', () => {
        homeControlDiv.style.backgroundColor = 'rgba(0,0,0,0.8)';
        homeControlDiv.querySelector('i').style.color = '#4285f4';
      });

      homeControlDiv.addEventListener('click', () => {
        this.cinematicReturnHome();
      });

      // Custom Locate Me Control with enhanced styling
      const locateControlDiv = document.createElement('div');
      locateControlDiv.style.margin = '10px';
      locateControlDiv.style.cursor = 'pointer';
      locateControlDiv.style.backgroundColor = 'rgba(0,0,0,0.8)';
      locateControlDiv.style.border = '2px solid #4285f4';
      locateControlDiv.style.borderRadius = '5px';
      locateControlDiv.style.boxShadow = '0 4px 15px rgba(66, 133, 244, 0.3)';
      locateControlDiv.style.textAlign = 'center';
      locateControlDiv.style.width = '45px';
      locateControlDiv.style.height = '45px';
      locateControlDiv.style.lineHeight = '45px';
      locateControlDiv.style.transition = 'all 0.3s ease';
      locateControlDiv.innerHTML = '<i class="mdi mdi-crosshairs-gps" style="font-size: 20px; color: #4285f4;"></i>';
      locateControlDiv.title = 'Lock onto Your Position';

      locateControlDiv.addEventListener('mouseenter', () => {
        locateControlDiv.style.backgroundColor = 'rgba(66, 133, 244, 0.9)';
        locateControlDiv.querySelector('i').style.color = 'white';
      });

      locateControlDiv.addEventListener('mouseleave', () => {
        locateControlDiv.style.backgroundColor = 'rgba(0,0,0,0.8)';
        locateControlDiv.querySelector('i').style.color = '#4285f4';
      });

      locateControlDiv.addEventListener('click', () => {
        this.getCurrentLocation();
      });

      // Add controls to map
      this.map.controls[google.maps.ControlPosition.LEFT_TOP].push(homeControlDiv);
      this.map.controls[google.maps.ControlPosition.LEFT_TOP].push(locateControlDiv);

      console.log('Enhanced orbital controls added successfully');
    },

    // Enhanced cinematic return to home view
    async cinematicReturnHome() {
      this.loadingStatus = `Ascending to ${this.countyData?.countyName || 'County'} overview...`;

      // Smooth animation back to default view with dramatic zoom out first
      const currentCenter = this.map.getCenter();
      const targetCenter = this.mapCenter; // Use county-specific center
      console.log('Returning to home center:', targetCenter);
      const currentZoom = this.map.getZoom();
      const targetZoom = 15; // Higher zoom for better detail

      // First, zoom out slightly for dramatic effect
      let tempZoom = currentZoom + 2;
      this.map.setZoom(tempZoom);

      setTimeout(() => {
        // Then animate to target
        let progress = 0;
        const animateInterval = setInterval(() => {
          progress += 0.03;
          if (progress >= 1) {
            progress = 1;
            clearInterval(animateInterval);
            this.loadingStatus = `${this.countyData?.countyName || 'County'} overview established`;
            setTimeout(() => this.loadingStatus = '', 2000);
          }

          // Smooth easing function for cinematic effect
          const easeProgress = 1 - Math.pow(1 - progress, 3);

          // Interpolate position and zoom
          const lat = currentCenter.lat() + (targetCenter.lat - currentCenter.lat()) * easeProgress;
          const lng = currentCenter.lng() + (targetCenter.lng - currentCenter.lng()) * easeProgress;
          const zoom = tempZoom + (targetZoom - tempZoom) * easeProgress;

          this.map.setCenter({ lat, lng });
          this.map.setZoom(zoom);
        }, 40);
      }, 300);
    },

    // Get current location with enhanced effects
    getCurrentLocation() {
      if (navigator.geolocation) {
        this.loadingStatus = 'Acquiring GPS satellite lock...';
        navigator.geolocation.getCurrentPosition(
            async (position) => {
              const pos = {
                lat: position.coords.latitude,
                lng: position.coords.longitude
              };

              // Add enhanced marker for current location
              if (this.currentLocationMarker) {
                this.currentLocationMarker.setMap(null);
              }

              this.currentLocationMarker = new google.maps.Marker({
                position: pos,
                map: this.map,
                title: 'Your Current Position',
                icon: {
                  url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(`
                  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="16" cy="16" r="12" fill="#4285f4" stroke="white" stroke-width="3" opacity="0.8"/>
                    <circle cx="16" cy="16" r="6" fill="white"/>
                    <circle cx="16" cy="16" r="16" fill="none" stroke="#4285f4" stroke-width="2" opacity="0.3"/>
                  </svg>
                `),
                  scaledSize: new google.maps.Size(32, 32),
                  anchor: new google.maps.Point(16, 16)
                },
                animation: google.maps.Animation.DROP
              });

              // Cinematic zoom to location
              this.loadingStatus = 'Centering on your position...';
              await this.cinematicZoomToLocation(pos);
              this.loadingStatus = '';
            },
            (error) => {
              console.error('GPS lock failed:', error);
              this.loadingStatus = 'Unable to acquire GPS lock';
              setTimeout(() => {
                this.loadingStatus = '';
              }, 3000);
            }
        );
      } else {
        alert('GPS satellite positioning is not supported by this device.');
      }
    },

    // Enhanced cinematic zoom to specific location
    async cinematicZoomToLocation(targetPos) {
      return new Promise((resolve) => {
        this.loadingStatus = 'Locking onto your coordinates...';

        const currentCenter = this.map.getCenter();
        const currentZoom = this.map.getZoom();
        const targetZoom = 18; // Very close zoom for precise location

        // Multi-stage approach for dramatic effect
        let stage = 1;
        let progress = 0;

        const animateInterval = setInterval(() => {
          progress += 0.025; // Slower for more dramatic effect

          if (progress >= 1) {
            progress = 1;
            clearInterval(animateInterval);
            this.loadingStatus = 'GPS lock established - precise positioning active';
            setTimeout(() => this.loadingStatus = '', 3000);
            resolve();
          }

          // Multi-stage easing for cinematic effect
          let easeProgress;
          if (progress < 0.3) {
            // Stage 1: Slow start
            easeProgress = Math.pow(progress / 0.3, 2) * 0.3;
            this.loadingStatus = 'Acquiring satellite lock...';
          } else if (progress < 0.7) {
            // Stage 2: Fast middle
            const midProgress = (progress - 0.3) / 0.4;
            easeProgress = 0.3 + midProgress * 0.5;
            this.loadingStatus = 'Descending to your location...';
          } else {
            // Stage 3: Slow end with precision
            const endProgress = (progress - 0.7) / 0.3;
            easeProgress = 0.8 + (1 - Math.pow(1 - endProgress, 3)) * 0.2;
            this.loadingStatus = 'Fine-tuning position lock...';
          }

          const lat = currentCenter.lat() + (targetPos.lat - currentCenter.lat()) * easeProgress;
          const lng = currentCenter.lng() + (targetPos.lng - currentCenter.lng()) * easeProgress;
          const zoom = currentZoom + (targetZoom - currentZoom) * easeProgress;

          this.map.setCenter({ lat, lng });
          this.map.setZoom(zoom);
        }, 50);
      });
    },

    // Remove the loadSampleData method entirely - we don't want sample data

    async processCadastralData(data) {
      try {
        this.loadingStatus = 'Rendering cadastral overlays...';

        // Add data to map with progressive loading effect
        await this.progressiveDataLoad(data);

        console.log('Satellite imagery overlays added to map');

        // Setup styling and events
        this.setupStyling();
        this.setupCadastralEventListeners();

        // Calculate stats if not already loaded via API
        if (this.compliantCount === 0 && this.arrearsCount === 0 && this.reviewCount === 0) {
          this.calculateStats();
        }

        // Zoom to fit the data with cinematic effect
        await this.cinematicFitBounds();

        this.loadingStatus = `Successfully rendered ${data.features?.length || 0} cadastral parcels`;
        console.log('Satellite cadastral data processed successfully');

        // Clear loading status after 3 seconds
        setTimeout(() => {
          this.loadingStatus = '';
        }, 3000);

      } catch (error) {
        console.error('Error processing satellite cadastral data:', error);
        this.loadingStatus = 'Error rendering cadastral overlays';
      }
    },

    // Progressive data loading for cinematic effect
    async progressiveDataLoad(data) {
      const features = data.features;
      const batchSize = Math.ceil(features.length / 10); // Load in 10 batches

      for (let i = 0; i < features.length; i += batchSize) {
        const batch = features.slice(i, i + batchSize);
        const batchData = {
          type: "FeatureCollection",
          features: batch
        };

        this.cadastralLayer.addGeoJson(batchData);

        const progress = Math.round(((i + batchSize) / features.length) * 100);
        this.loadingStatus = `Rendering parcels... ${Math.min(progress, 100)}%`;

        // Small delay for cinematic effect
        await new Promise(resolve => setTimeout(resolve, 100));
      }
    },

    // Enhanced cinematic fit bounds
    async cinematicFitBounds() {
      const bounds = new google.maps.LatLngBounds();
      let featureCount = 0;

      this.cadastralLayer.forEach(feature => {
        featureCount++;
        const geometry = feature.getGeometry();
        if (geometry) {
          geometry.forEachLatLng(latLng => {
            bounds.extend(latLng);
          });
        }
      });

      if (!bounds.isEmpty()) {
        // Multi-stage dramatic zoom and fit
        this.loadingStatus = 'Calculating optimal orbital viewing angle...';

        // First, zoom out dramatically
        const currentZoom = this.map.getZoom();
        this.map.setZoom(8);

        await new Promise(resolve => setTimeout(resolve, 800));

        this.loadingStatus = 'Positioning for optimal cadastral overview...';

        // Then smoothly fit to bounds with higher detail
        const listener = this.map.addListener('bounds_changed', () => {
          google.maps.event.removeListener(listener);
          // After fitting, zoom in a bit more for better detail
          setTimeout(() => {
            const currentZoom = this.map.getZoom();
            if (currentZoom < 14) {
              this.map.setZoom(Math.min(currentZoom + 2, 16)); // Zoom in more for better visibility
            }
            this.loadingStatus = 'Orbital view optimized for cadastral analysis';
            setTimeout(() => this.loadingStatus = '', 2000);
          }, 1000);
        });

        this.map.fitBounds(bounds);
        const padding = { top: 80, right: 80, bottom: 80, left: 80 }; // More padding for better view
        this.map.fitBounds(bounds, padding);
      }
    },

    // Enhanced toggle map type
    toggleMapType() {
      this.mapType = this.mapType === 'satellite' ? 'roadmap' : 'satellite';
      this.map.setMapTypeId(this.mapType);

      // Add subtle loading effect
      this.loadingStatus = `Switching to ${this.mapType} view...`;
      setTimeout(() => {
        this.loadingStatus = '';
      }, 1000);
    },

    setupStyling() {
      console.log('Setting up enhanced polygon styling...');

      this.cadastralLayer.setStyle((feature) => {
        const status = feature.getProperty("Status");
        const payBal = feature.getProperty("CurrentBal") || 0;

        let styleOptions = {
          fillColor: "#28a745",
          fillOpacity: 0.5,
          strokeColor: "#28a745",
          strokeWeight: 2,
          strokeOpacity: 0.9
        };

        if (payBal > 0) {
          styleOptions = {
            fillColor: "#dc3545",
            fillOpacity: 0.5,
            strokeColor: "#dc3545",
            strokeWeight: 2,
            strokeOpacity: 0.9
          };
        }

        if (status && status.toLowerCase() === "uncompliant") {
          styleOptions = {
            fillColor: "#dc3545",
            fillOpacity: 0.5,
            strokeColor: "#dc3545",
            strokeWeight: 2,
            strokeOpacity: 0.9
          };
        } else if (status && status.toLowerCase() === "testing") {
          styleOptions = {
            fillColor: "#ffc107",
            fillOpacity: 0.6,
            strokeColor: "#ffc107",
            strokeWeight: 2,
            strokeOpacity: 0.9
          };
        } else if (status && status.toLowerCase() === "compliant") {
          styleOptions = {
            fillColor: "#28a745",
            fillOpacity: 0.5,
            strokeColor: "#28a745",
            strokeWeight: 2,
            strokeOpacity: 0.9
          };
        }

        return styleOptions;
      });

      console.log('Enhanced polygon styling applied');
    },

    setupCadastralEventListeners() {
      console.log('Setting up enhanced event listeners...');

      this.cadastralLayer.addListener('mouseover', (event) => {
        const feature = event.feature;
        const arrears = feature.getProperty("CurrentBal") || 0;
        const followText = document.getElementById("follow-text");

        if (followText) {
          if (arrears > 0) {
            followText.innerHTML = `🛰️ <strong class='text-danger'>Outstanding: KES ${this.formatWithCommas(arrears)}</strong> <br> <span class="text-info">Click for orbital view</span>`;
          } else {
            followText.innerHTML = "🛰️ <strong class='text-success'>Compliant</strong> <br> <span class='text-info'>Click for orbital details</span>";
          }
          followText.classList.remove('d-none');
        }
      });

      this.cadastralLayer.addListener('mouseout', () => {
        const followText = document.getElementById("follow-text");
        if (followText) {
          followText.classList.add('d-none');
        }
      });

      this.cadastralLayer.addListener('click', (event) => {
        console.log('Plot selected for orbital analysis:', event.feature.getProperty("UPN"));
        this.handlePlotClick(event);
      });

      document.addEventListener("mousemove", (e) => {
        const followText = document.getElementById("follow-text");
        if (followText && !followText.classList.contains('d-none')) {
          // Get the map container to calculate relative position
          const mapContainer = document.querySelector('.main-map-container');
          if (mapContainer) {
            const mapRect = mapContainer.getBoundingClientRect();

            // Calculate position relative to the map container
            const relativeX = e.clientX - mapRect.left;
            const relativeY = e.clientY - mapRect.top;

            // Position tooltip near cursor but within map bounds
            let tooltipX = relativeX + 15;
            let tooltipY = relativeY - 10;

            // Ensure tooltip doesn't go outside map container
            const tooltipWidth = 200; // max-width from CSS
            const tooltipHeight = 60; // approximate height

            if (tooltipX + tooltipWidth > mapRect.width) {
              tooltipX = relativeX - tooltipWidth - 15;
            }

            if (tooltipY < 0) {
              tooltipY = relativeY + 20;
            }

            if (tooltipY + tooltipHeight > mapRect.height) {
              tooltipY = relativeY - tooltipHeight - 20;
            }

            followText.style.left = tooltipX + "px";
            followText.style.top = tooltipY + "px";
          }
        }
      });

      document.addEventListener('click', (e) => {
        if (e.target.classList.contains('close-aside') || e.target.classList.contains('ma-backdrop')) {
          this.closeSidePanel();
        }
      });

      console.log('Enhanced event listeners activated');
    },

    handlePlotClick(event) {
      const followText = document.getElementById("follow-text");
      if (followText) {
        followText.classList.add('d-none');
      }

      const feature = event.feature;
      this.currentFeature = feature;
      this.showPlotDetails(feature, event.latLng);
    },

    showPlotDetails(feature, latLng) {
      const panel = document.getElementById("mapCanvas");
      const backdrop = document.querySelector(".ma-backdrop");

      if (!panel || !backdrop) {
        console.error('Panel or backdrop elements not found');
        return;
      }

      this.populatePlotDetails(feature);
      this.getAddressFromCoordinates(latLng.lat(), latLng.lng(), (address) => {
        const addressEl = document.querySelector('.the-clicked-address');
        if (addressEl) {
          addressEl.textContent = address;
        }
      });

      panel.classList.remove('left-100');
      backdrop.classList.remove('d-none');
    },

    populatePlotDetails(feature) {
      const currentBal = feature.getProperty("CurrentBal") || 0;
      const statusEl = document.querySelector('.plot-status');
      const balanceEl = document.querySelector('.balance-txt');

      if (statusEl && balanceEl) {
        if (currentBal > 0) {
          statusEl.className = 'alert plot-status border-2 mb-3 alert-danger border-danger';
          balanceEl.className = 'balance-txt fw-bold balances text-danger';
        } else {
          statusEl.className = 'alert plot-status border-2 mb-3 alert-success border-success';
          balanceEl.className = 'balance-txt fw-bold balances text-success';
        }
      }

      // Populate all fields
      const ownerNameEl = document.querySelector('.owner-name');
      if (ownerNameEl) ownerNameEl.textContent = feature.getProperty("CustomerSu") || '-';

      const lrNoEl = document.querySelector('.lr-no');
      if (lrNoEl) lrNoEl.textContent = feature.getProperty("Parcel_No") || feature.getProperty("LR_No") || '-';

      const blockNameEl = document.querySelector('.block-name');
      if (blockNameEl) blockNameEl.textContent = feature.getProperty("Block_Name") || '-';

      const plotNumberEl = document.querySelector('.plot-number');
      if (plotNumberEl) plotNumberEl.textContent = feature.getProperty("Plot_No") || '-';

      const upnEl = document.querySelector('.upn');
      if (upnEl) upnEl.textContent = feature.getProperty("UPN") || '-';

      const sizeEl = document.querySelector('.size');
      if (sizeEl) sizeEl.textContent = (feature.getProperty("AreaInHa") || 0) + " Ha";

      const marketEl = document.querySelector('.market');
      if (marketEl) marketEl.textContent = feature.getProperty("MarketCent") || '-';

      const siteValueEl = document.querySelector('.site-value');
      if (siteValueEl) siteValueEl.textContent = "KES " + this.formatWithCommas(feature.getProperty("SiteValue") || 0) + ".00";

      const balancesEl = document.querySelector('.balances');
      if (balancesEl) balancesEl.textContent = "KES " + this.formatWithCommas(currentBal) + ".00";

      const annualChargesEl = document.querySelector('.annual-charges');
      if (annualChargesEl) annualChargesEl.textContent = "KES " + this.formatWithCommas(feature.getProperty("TotalAnnua") || 0) + ".00";

      const landRateEl = document.querySelector('.land-rate');
      if (landRateEl) landRateEl.textContent = "KES " + this.formatWithCommas(feature.getProperty("LandRates") || 0) + ".00";

      const groundRateEl = document.querySelector('.ground-rate');
      if (groundRateEl) groundRateEl.textContent = "KES " + this.formatWithCommas(feature.getProperty("GroundRent") || 0) + ".00";

      const otherChargesEl = document.querySelector('.other-charges');
      if (otherChargesEl) otherChargesEl.textContent = "KES " + this.formatWithCommas(feature.getProperty("OtherCharg") || 0) + ".00";
    },

    getAddressFromCoordinates(lat, lng, callback) {
      if (typeof google === 'undefined' || !google.maps || !google.maps.Geocoder) {
        callback("Geocoder offline");
        return;
      }

      const geocoder = new google.maps.Geocoder();
      const latLng = new google.maps.LatLng(lat, lng);

      geocoder.geocode({ 'location': latLng }, (results, status) => {
        if (status === google.maps.GeocoderStatus.OK) {
          if (results[0]) {
            callback(results[0].formatted_address);
          } else {
            callback("Address not found in satellite database");
          }
        } else {
          callback("Geocoder offline: " + status);
        }
      });
    },

    calculateStats() {
      if (!this.cadastralData) return;

      let compliant = 0;
      let arrears = 0;
      let review = 0;

      this.cadastralData.features.forEach(feature => {
        const balance = feature.properties.CurrentBal || 0;
        const status = feature.properties.Status || '';

        if (status.toLowerCase() === 'testing') {
          review++;
        } else if (balance > 0) {
          arrears++;
        } else {
          compliant++;
        }
      });

      this.compliantCount = compliant;
      this.arrearsCount = arrears;
      this.reviewCount = review;
    },

    formatWithCommas(number) {
      const num = parseFloat(number);
      if (isNaN(num)) return "0";
      return num.toLocaleString();
    },

    formatBytes(bytes, decimals = 2) {
      if (bytes === 0) return '0 Bytes';
      const k = 1024;
      const dm = decimals < 0 ? 0 : decimals;
      const sizes = ['Bytes', 'KB', 'MB', 'GB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    },

    async clearCache() {
      try {
        const transaction = this.cadastralDB.transaction(['cadastralData'], 'readwrite');
        const store = transaction.objectStore('cadastralData');
        await store.delete('main');
        console.log('Orbital cache cleared successfully');
        this.loadingStatus = 'Orbital cache cleared. Refresh to download fresh data.';
      } catch (error) {
        console.error('Error clearing orbital cache:', error);
      }
    },

    viewFullDetails() {
      if (this.currentFeature) {
        console.log('Accessing full orbital analysis for:', this.currentFeature.getProperty("UPN"));
        this.$router.push(`/plot-details/${this.currentFeature.getProperty("UPN")}`);
      }
    },

    generateStatement() {
      if (this.currentFeature) {
        console.log('Generating orbital statement for:', this.currentFeature.getProperty("UPN"));
      }
    },

    exportData() {
      console.log('Exporting satellite cadastral data...');
      this.loadingStatus = 'Preparing orbital data export...';
      setTimeout(() => {
        this.loadingStatus = '';
      }, 2000);
    },

    reloadData() {
      this.loadingStatus = 'Reestablishing satellite connection...';
      this.cadastralData = null;
      this.compliantCount = 0;
      this.arrearsCount = 0;
      this.reviewCount = 0;

      if (this.cadastralLayer) {
        this.cadastralLayer.setMap(null);
        this.cadastralLayer = new google.maps.Data({
          map: this.map,
          clickable: true
        });
      }

      this.initializeCadastralData();
    },

    closeSidePanel() {
      const panel = document.getElementById("mapCanvas");
      const backdrop = document.querySelector(".ma-backdrop");

      if (panel) {
        panel.classList.add('left-100');
      }
      if (backdrop) {
        backdrop.classList.add('d-none');
      }
    },

    toggleMeasurementTool() {
      if (this.measurementMode) {
        this.disableMeasurementTool();
      } else {
        this.enableMeasurementTool();
      }
    },

    enableMeasurementTool() {
      this.measurementMode = true;
      this.map.setOptions({ draggableCursor: 'crosshair' });
      this.loadingStatus = 'Orbital measurement tool activated';

      if (this.measurementOverlays) {
        this.measurementOverlays.forEach(overlay => overlay.setMap(null));
      }
      this.measurementOverlays = [];
      this.measurementPath = [];

      this.measurementListener = this.map.addListener('click', (event) => {
        this.addMeasurementPoint(event.latLng);
      });

      setTimeout(() => {
        if (this.measurementMode) {
          this.loadingStatus = '';
        }
      }, 3000);
    },

    disableMeasurementTool() {
      this.measurementMode = false;
      this.map.setOptions({ draggableCursor: null });

      if (this.measurementListener) {
        google.maps.event.removeListener(this.measurementListener);
      }

      if (this.measurementOverlays) {
        this.measurementOverlays.forEach(overlay => overlay.setMap(null));
        this.measurementOverlays = [];
      }
      this.measurementPath = [];
      this.loadingStatus = 'Orbital measurement tool deactivated';

      setTimeout(() => {
        this.loadingStatus = '';
      }, 2000);
    },

    addMeasurementPoint(latLng) {
      this.measurementPath.push(latLng);

      // Add enhanced marker
      const marker = new google.maps.Marker({
        position: latLng,
        map: this.map,
        icon: {
          url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(`
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="8" cy="8" r="6" fill="#dc3545" stroke="white" stroke-width="2"/>
              <circle cx="8" cy="8" r="2" fill="white"/>
            </svg>
          `),
          scaledSize: new google.maps.Size(16, 16),
          anchor: new google.maps.Point(8, 8)
        },
        animation: google.maps.Animation.DROP
      });

      this.measurementOverlays.push(marker);

      if (this.measurementPath.length > 1) {
        const polyline = new google.maps.Polyline({
          path: this.measurementPath,
          geodesic: true,
          strokeColor: '#dc3545',
          strokeOpacity: 1.0,
          strokeWeight: 3,
          map: this.map
        });

        this.measurementOverlays.push(polyline);

        const distance = this.calculateDistance();
        this.showDistanceLabel(latLng, distance);
      }
    },

    calculateDistance() {
      let totalDistance = 0;
      for (let i = 1; i < this.measurementPath.length; i++) {
        totalDistance += google.maps.geometry.spherical.computeDistanceBetween(
            this.measurementPath[i - 1],
            this.measurementPath[i]
        );
      }
      return totalDistance;
    },

    showDistanceLabel(position, distance) {
      let distanceText;
      if (distance < 1000) {
        distanceText = `${Math.round(distance)} m`;
      } else {
        distanceText = `${(distance / 1000).toFixed(2)} km`;
      }

      const infoWindow = new google.maps.InfoWindow({
        content: `<div style="padding: 8px; font-weight: bold; color: #dc3545; background: rgba(0,0,0,0.8); border-radius: 5px;">
                    🛰️ Distance: ${distanceText}
                    <br><small style="color: #ccc;">Click to continue measuring</small>
                  </div>`,
        position: position
      });

      infoWindow.open(this.map);
      this.measurementOverlays.push(infoWindow);
    },

    fitAllPlots() {
      if (!this.cadastralLayer) return;

      const bounds = new google.maps.LatLngBounds();
      let hasData = false;

      this.cadastralLayer.forEach(feature => {
        hasData = true;
        const geometry = feature.getGeometry();
        if (geometry) {
          geometry.forEachLatLng(latLng => {
            bounds.extend(latLng);
          });
        }
      });

      if (hasData && !bounds.isEmpty()) {
        this.loadingStatus = 'Repositioning for complete cadastral overview...';

        // Dramatic zoom out first
        this.map.setZoom(8);

        setTimeout(() => {
          this.map.fitBounds(bounds);
          const padding = { top: 80, right: 80, bottom: 80, left: 80 };
          this.map.fitBounds(bounds, padding);

          // Then zoom in for better detail
          setTimeout(() => {
            const currentZoom = this.map.getZoom();
            this.map.setZoom(Math.min(currentZoom + 2, 16));
            this.loadingStatus = 'Complete cadastral overview established';
            setTimeout(() => this.loadingStatus = '', 2000);
          }, 1000);
        }, 800);
      }
    }
  },

  beforeUnmount() {
    // Clean up measurement tool
    if (this.measurementListener) {
      google.maps.event.removeListener(this.measurementListener);
    }

    // Clean up measurement overlays
    if (this.measurementOverlays) {
      this.measurementOverlays.forEach(overlay => overlay.setMap(null));
    }

    // Clean up current location marker
    if (this.currentLocationMarker) {
      this.currentLocationMarker.setMap(null);
    }
  }
}
</script>

<style scoped>
/* Enhanced styles for cinematic effect */
.main-map-container {
  position: relative;
  overflow: hidden;
  border-radius: 8px;
  box-shadow: 0 8px 32px rgba(0,0,0,0.3);
}

.map-details-panel {
  transition: transform 0.3s ease-in-out;
  overflow-y: auto;
  backdrop-filter: blur(10px);
  background: rgba(255, 255, 255, 0.95) !important;
}

.map-details-panel.left-100 {
  transform: translateX(100%);
}

.ma-backdrop {
  background: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(2px);
}

#follow-text {
  pointer-events: none;
  font-size: 12px;
  max-width: 200px;
  backdrop-filter: blur(10px);
  background: rgba(0, 0, 0, 0.8) !important;
  border: 1px solid rgba(66, 133, 244, 0.3);
  position: absolute;
  z-index: 1000;
  padding: 8px;
  border-radius: 4px;
  white-space: nowrap;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

.badge-soft-success {
  background-color: rgba(40, 167, 69, 0.15);
  color: #28a745;
  border: 1px solid rgba(40, 167, 69, 0.3);
}

.badge-soft-danger {
  background-color: rgba(220, 53, 69, 0.15);
  color: #dc3545;
  border: 1px solid rgba(220, 53, 69, 0.3);
}

.badge-soft-warning {
  background-color: rgba(255, 193, 7, 0.15);
  color: #ffc107;
  border: 1px solid rgba(255, 193, 7, 0.3);
}

.badge-soft-info {
  background-color: rgba(66, 133, 244, 0.15);
  color: #4285f4;
  border: 1px solid rgba(66, 133, 244, 0.3);
}

/* Cinematic Loading Overlay */
.cinematic-overlay {
  background: linear-gradient(135deg,
  rgba(0, 0, 0, 0.95) 0%,
  rgba(66, 133, 244, 0.1) 25%,
  rgba(0, 0, 0, 0.95) 50%,
  rgba(66, 133, 244, 0.1) 75%,
  rgba(0, 0, 0, 0.95) 100%);
  background-size: 400% 400%;
  animation: gradientShift 8s ease-in-out infinite;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

@keyframes gradientShift {
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
}

.cinematic-content {
  text-align: center;
  z-index: 10;
}

.earth-animation {
  margin-bottom: 2rem;
}

.rotating-earth {
  animation: rotate 4s linear infinite, pulse 2s ease-in-out infinite alternate;
  display: inline-block;
}

@keyframes rotate {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

@keyframes pulse {
  from {
    transform: scale(1);
    filter: drop-shadow(0 0 10px rgba(66, 133, 244, 0.5));
  }
  to {
    transform: scale(1.1);
    filter: drop-shadow(0 0 20px rgba(66, 133, 244, 0.8));
  }
}

.loading-text h4 {
  text-shadow: 0 0 20px rgba(66, 133, 244, 0.5);
  margin-bottom: 1rem;
}

.scanning-line {
  width: 300px;
  height: 2px;
  background: linear-gradient(90deg,
  transparent 0%,
  #4285f4 25%,
  #4285f4 75%,
  transparent 100%);
  margin: 1rem auto;
  animation: scan 2s ease-in-out infinite;
  box-shadow: 0 0 10px rgba(66, 133, 244, 0.8);
}

@keyframes scan {
  0% { transform: translateX(-100px); opacity: 0; }
  50% { opacity: 1; }
  100% { transform: translateX(100px); opacity: 0; }
}

.cinematic-progress {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  overflow: hidden;
  backdrop-filter: blur(5px);
}

.cinematic-bar {
  background: linear-gradient(90deg, #4285f4, #34a853, #fbbc05, #ea4335);
  background-size: 200% 100%;
  animation: progressFlow 2s ease-in-out infinite;
}

@keyframes progressFlow {
  0% { background-position: 0% 50%; }
  100% { background-position: 200% 50%; }
}

.cinematic-main-progress {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 5px;
  overflow: hidden;
  backdrop-filter: blur(5px);
  width: 300px;
  margin: 0 auto;
}

.bg-gradient-primary {
  background: linear-gradient(90deg, #4285f4, #34a853) !important;
  transition: width 0.3s ease;
}

/* Map loading effect */
.map-loading {
  filter: brightness(0.7) saturate(0.8);
  transition: filter 0.5s ease;
}

/* Enhanced progress bar */
.progress {
  border-radius: 10px;
  overflow: hidden;
  backdrop-filter: blur(5px);
}

.progress-bar {
  transition: width 0.3s ease;
}

/* Animation classes */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInRight {
  from {
    opacity: 0;
    transform: translateX(20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.animate__animated {
  animation-duration: 0.8s;
  animation-fill-mode: both;
}

.animate__fadeInUp {
  animation-name: fadeInUp;
}

.animate__fadeInRight {
  animation-name: fadeInRight;
}

.animate__pulse {
  animation-name: pulse;
  animation-duration: 1.5s;
}

.animate__infinite {
  animation-iteration-count: infinite;
}

.animate__delay-1s {
  animation-delay: 1s;
}

/* Enhanced button styling */
.btn {
  transition: all 0.3s ease;
  backdrop-filter: blur(5px);
}

.btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(0,0,0,0.2);
}

.btn-primary {
  background: linear-gradient(135deg, #4285f4, #34a853);
  border: none;
}

.btn-success {
  background: linear-gradient(135deg, #34a853, #28a745);
  border: none;
}

.btn-info {
  background: linear-gradient(135deg, #17a2b8, #4285f4);
  border: none;
}

.btn-warning {
  background: linear-gradient(135deg, #ffc107, #ff9800);
  border: none;
}

.btn-secondary {
  background: linear-gradient(135deg, #6c757d, #495057);
  border: none;
}

/* Enhanced card styling */
.card {
  backdrop-filter: blur(10px);
  background: rgba(255, 255, 255, 0.95);
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0 8px 32px rgba(0,0,0,0.1);
}

/* County banner styling */
.card.border-primary {
  border-color: #4285f4 !important;
  background: linear-gradient(135deg, rgba(66, 133, 244, 0.05), rgba(255, 255, 255, 0.98));
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .map-details-panel {
    width: 100% !important;
  }

  .cinematic-overlay .scanning-line {
    width: 200px;
  }

  .cinematic-main-progress {
    width: 250px;
  }

  .earth-animation {
    margin-bottom: 1rem;
  }

  .rotating-earth i {
    font-size: 60px !important;
  }
}

@media (max-width: 576px) {
  .cinematic-overlay .scanning-line {
    width: 150px;
  }

  .cinematic-main-progress {
    width: 200px;
  }

  .rotating-earth i {
    font-size: 50px !important;
  }
}
</style>